// Původní název:		invia.initRowClick
// Původní umístění:	shared/js/main-desktop.js
// Status:				Používané
// Funkcionalita:		Umožní kliknout kdekoliv na řádek a přejít na odkaz v něm
// Použito:				Last Minute > tabulky s top zeměmi
//						DH > Volné termíny > Filtry a řazení > tabulka s termíny v lightboxu
// #CHECKED jthiemel 190109


import $ from 'jquery';


export const init = ($target) => {
	$('body').on('click', '.row-click tr', function () {
		window.location = $(this).find('a').attr('href');
	});
};
